import React from 'react';
import { walkClaimText } from '../../../../lib/walkClaimText';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { walkCitationText } from '../../../../lib/walkCitationText';
import { EditorialSubsection } from '../../report/editorial';

export const CoolingByTechSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const text = report.waterAnalysis?.coolingWaterRequirements;
  // R-BTM-DILIGENCE — the OPTIONAL water↔PUE tradeoff (dry/ZLD cooling cuts
  // withdrawal but raises PUE → more generation MW). The prompt routes this
  // into coolingWaterRequirements AND the consumptiveUse.dryCoolingPueTradeoff
  // sub-field; render it here (the cooling host) as a second subsection,
  // citation-walked, and OR its presence into hasData.
  const tradeoff = report.waterAnalysis?.consumptiveUse?.dryCoolingPueTradeoff?.trim();
  return (
    <SectionShell label={label} hasData={!!text || !!tradeoff}>
      {text && (
        <EditorialSubsection theme={theme} label="Cooling Water Requirements">
          {walkClaimText(text, report.references)}
        </EditorialSubsection>
      )}
      {tradeoff && (
        <EditorialSubsection theme={theme} label="Dry-Cooling / ZLD ↔ PUE Tradeoff">
          {walkCitationText(tradeoff, report.references)}
        </EditorialSubsection>
      )}
    </SectionShell>
  );
};
